import React, { useState } from "react";

import styled from "styled-components";
import moment from "moment";

import { useTheme } from '../../../../Context/ThemeContext';
import { useLanguage } from '../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import UserProfile from "../../../../Component/Normal/UserProfile";

import { ReactComponent as CheckSvg } from '../../../../image/Check2.svg';

export default function ReservedMemberInfoBox(props) {
  const {
    memberData,
    index,
    totalLength,
    onViewUserPhone,
    onCalcButtonText,
    onClickMemberProfileOrText,
    onClickMemberExceptButton,
    onClickAttendanceButton
  } = props;

  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [isHover, setIsHover] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

  // 호버 시 툴팁 위치 계산 //
  function onMouseEnterInfoWrapper(e) {
    const rect = e.currentTarget.getBoundingClientRect();

    setTooltipPos({ top: rect.top - 5, left: rect.left + 93 });
    setIsHover(true);
  }

  // 회원권 남은 일수 표출여부 확인 //
  function isViewRemainMembership() {
    if (memberData.endDate === undefined) return false;

    const dateDiff = moment(memberData.endDate).diff(moment(), 'day');

    if (dateDiff > 7) return false;
    return true;
  }

  // 회원권 남은 일수 계산 //
  function decideRemainMembership() {
    const dateDiff = moment(memberData.endDate).diff(moment(), 'day');

    if (dateDiff === 0) return 'D-DAY';
    return 'D-' + dateDiff;
  }

  return (
    <InfoWrapper key={'Reserve-' + index}>
      <ImageTooltipWrapper isHover={isHover} top={tooltipPos.top} left={tooltipPos.left}>
        <ImageTooltip>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subBackground} cursor='default'>
            {t('reservation.requestTime') + moment(memberData.createdDate).format(t('reservation.requestDateFormat'))}
          </Text>
        </ImageTooltip>
        <Triangle />
      </ImageTooltipWrapper>

      <MemberDataWrapper>
        <MemberInfoWrapper onMouseEnter={onMouseEnterInfoWrapper} onMouseLeave={() => setIsHover(false)}>
          <ImageWrapper
            onClick={() => onClickMemberProfileOrText(memberData)}>
            <UserProfile profile={memberData.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
          </ImageWrapper>

          <ReserveNumberWrapper>
            <TotalTextWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
              <TextWrapper>
                <NameWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{memberData.name}</Text>
                </NameWrapper>
                <PhoneWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='pointer'>{onViewUserPhone(memberData.phone, memberData.countryCode)}</Text>
                </PhoneWrapper>
              </TextWrapper>
            </TotalTextWrapper>
          </ReserveNumberWrapper>
        </MemberInfoWrapper>

        <ReserveDdayBox isView={isViewRemainMembership()}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='pointer'>{decideRemainMembership()}</Text>
        </ReserveDdayBox>

        <AttendanceCheckBox isComplete={(memberData.status === 1 || memberData.status === 2)}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={13} color={theme.subText} cursor='pointer'>{t('classManage.attendanceConfirmed')}</Text>
          <AttendanceCheck $isComplete={memberData.status === 1 || memberData.status === 2} onClick={() => onClickAttendanceButton(memberData)}>
            {
              (memberData.status === 1 || memberData.status === 2) &&
              <StyledCheck />
            }
          </AttendanceCheck>
        </AttendanceCheckBox>

        <ReserveExitButton onClick={() => onClickMemberExceptButton(index)}>
          <ExitPlusText>+</ExitPlusText>
        </ReserveExitButton>
      </MemberDataWrapper>

      <DivisionLineWrapper>
        <DivisionLine />
      </DivisionLineWrapper>
    </InfoWrapper>
  );
}

const InfoWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 45px;

  overflow: visible;

  &:hover {
    cursor: pointer;
  }
`;

const ImageWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  margin-right: 10px;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 3px;

  overflow: hidden;

  & img {
    width: 42px;
    height: 42px;
    border-radius: 3px;
    object-fit: cover;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ImageTooltipWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  top: ${props => props.top}px;
  left: ${props => props.left}px;

  opacity: ${props => props.isHover ? 1 : 0};

  z-index: ${props => props.isHover ? 1 : -1};

  transition: opacity 0.3s ease-in-out;
`;

const ImageTooltip = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 5px;

  border-radius: 3px;
  background-color:${props => props.theme.primary};
`;

const Triangle = styled.div`
  margin-left: 10px;

  width: 0;
  height: 0;

  border-top: 5px solid ${props => props.theme.primary};
  border-right: 16px solid transparent;
`;

const MemberDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  min-width: 0;
  height: 42px;

  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 200px;

  gap: 10px;
`;

const ReserveNumberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  overflow: hidden;
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  min-width: 147px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  min-width: 0;

  margin-bottom: 4px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const NameWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PhoneWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const ReserveExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 25px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ExitPlusText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 19px;

  color: ${props => props.theme.line};

  margin: 0;

  transform: rotate(45deg);

  transition: color 0.3s;

  @media (hover: hover) {
    &:hover {
      color: ${props => props.theme.pointRed};
    }
  }
`;


const ReserveDdayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 46px;
  height: 18px;

  border-radius: 100px;
  background-color: ${props => props.theme.primary};

  opacity: ${props => props.isView ? 1 : 0};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const AttendanceCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 100%;

  gap: 5px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AttendanceCheck = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 22px;
  height: 22px;

  border-radius: 22px;
  background-color: ${props => props.$isComplete ? props.theme.subKey : 'none'};
  border: ${props => props.$isComplete ? `1px solid ${props.theme.subKey}` : `1px dashed ${props.theme.line}`};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledCheck = styled(CheckSvg)`
  flex-shrink: 0;
  width: 11px;
  height: auto;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const DivisionLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 1px 7px 1px 45.5px;

  box-sizing: border-box;
  width: 100%;
  height: 3px;
`

const DivisionLine = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;
